import { css } from '@emotion/css';

export const tableContainer = css({
  display: 'block',
  padding: '10px 0 18px 10px',
  overflowX: 'auto',
  overflowY: 'visible',
  // 确保容器不会影响其他元素的自适应换行
  width: '100%',
  maxWidth: '100%',
  // 防止表格内容强制换行
  whiteSpace: 'nowrap',
  '::-webkit-scrollbar': {
    height: '8px',
  },
  '::-webkit-scrollbar-thumb:horizontal': {
    borderRadius: '4px',
    backgroundColor: 'transparent',
  },
  '::-webkit-scrollbar-track:horizontal': {
    backgroundColor: 'transparent',
    height: '8px',
  },
  '&:hover::-webkit-scrollbar-thumb:horizontal': {
    borderRadius: '4px',
    backgroundColor: 'var(--affine-black-30)',
  },
  '&:hover::-webkit-scrollbar-track:horizontal': {
    backgroundColor: 'var(--affine-hover-color)',
    height: '8px',
  },
});

export const tableWrapper = css({
  overflow: 'visible',
  display: 'table',
  borderCollapse: 'collapse',
  position: 'relative',
  width: '100%', // 改为100%确保宽度生效
  minWidth: '100%',
  // 使用auto布局让表格根据内容自适应
  tableLayout: 'auto',
});

export const table = css({});

export const rowStyle = css({});
